module.exports = __webpack_public_path__ + "img/nextpage.8e232fa0.png";